import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import { ROUTES } from 'constants/routes';
import { fetchResources, selectResourcesPage } from 'store/slices/ResourcesSlice';
import ProductCards from 'components/ProductCards';
import { scrollToSection } from 'helpers';

const Resources = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchResources());
    }, [dispatch]);

    const {
        fs_title,
        fs_view_button,
        fs_title_background,
        agricultural_tag,
        agricultural_title,
        agricultural_description,
        crop_nutrition_programs,
        trial_results,
        information_materials,
    } = useSelector(selectResourcesPage);

    const resourcesData = [
        { slug: ROUTES.cropNutritionPrograms, ...crop_nutrition_programs },
        { slug: ROUTES.trialResults, ...trial_results },
        { slug: ROUTES.informationMaterials, ...information_materials },
    ];

    const handleClick = () => scrollToSection('product-card-container', 100);

    return (
        <>
            <Banner
                title={fs_title}
                image={fs_title_background}
                buttonText={fs_view_button}
                onClickButton={handleClick}
            />
            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                <span dangerouslySetInnerHTML={{ __html: agricultural_description }} />
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <ProductCards data={resourcesData} />
        </>
    );
};

export default Resources;
